const UPDATE_HEADER_PROPS = '@@layout/UPDATE_HEADR_PROPS';


export default {
	UPDATE_HEADER_PROPS,
};
